import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { enableItemFromSerendipity, disableItemFromSerendipity } from 'modules/serendipity/actions';
import { bindActionCreators } from 'redux';
import ThinkSeedSmallCard from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.thinkSeedSmallCard,
    itemsPreferencesFromSerendipity: state.serendipity.preferences,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    enableItemFromSerendipity: bindActionCreators(enableItemFromSerendipity, dispatch),
    disableItemFromSerendipity: bindActionCreators(disableItemFromSerendipity, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThinkSeedSmallCard));



// WEBPACK FOOTER //
// ./src/components/Cards/ThinkSeedSmallCard/container/index.js